import ConsumptionAccounting from "../../../utils/services/project/accounting/consumptionAccountingService";

const state = {
  list: [],
  id: ""
};
const getters = {
  getList(state) {
    return state.list;
  }
};

const actions = {
  getConsumptionList({ commit }, { params = {}, onSuccess = () => {} }) {
    return ConsumptionAccounting.getConsumptionList(params, ({ list }) => {
      commit("setList", {
        list
      });
      onSuccess({ list });
    });
  },
  getConsumptionListParticle(
    { commit, state },
    { params = {}, onSuccess = () => {} }
  ) {
    let id = state.id;
    return ConsumptionAccounting.getConsumptionList(params, ({ list }) => {
      commit("setListParticle", {
        index: params.index,
        list,
        id
      });
      onSuccess({ list });
    });
  },
  getCountsList({ commit }, { params = {}, onSuccess = () => {} }) {
    return ConsumptionAccounting.getCountsList(params, ({ list }) => {
      commit("setList", {
        list
      });
      onSuccess({ list });
    });
  },
  getCountsListParticle(
    { commit, state },
    { params = {}, onSuccess = () => {} }
  ) {
    let id = state.id;
    return ConsumptionAccounting.getCountsList(params, ({ list }) => {
      commit("setListParticle", {
        index: params.index,
        list,
        id
      });
      onSuccess({ list });
    });
  },
  getProportionsList({ commit }, { params = {}, onSuccess = () => {} }) {
    return ConsumptionAccounting.getProportionsList(params, ({ list }) => {
      commit("setList", {
        list
      });
      onSuccess({ list });
    });
  },
  getProportionListParticle(
    { commit, state },
    { params = {}, onSuccess = () => {} }
  ) {
    let id = state.id;
    return ConsumptionAccounting.getConsumptionList(params, ({ list }) => {
      commit("setListParticle", {
        index: params.index,
        list,
        id
      });
      onSuccess({ list });
    });
  },
  create(_, { params, errorHandler = () => {}, onSuccess = () => {} }) {
    return ConsumptionAccounting.create(
      params,
      onSuccess,
      () => {},
      errorHandler
    );
  }
};

const mutations = {
  setListParticle(state, { list, index, id }) {
    if (id === state.id) {
      state.list.splice(index, 1, list[0]);
    }
  },
  setList(state, { list }) {
    state.list = list;
    state.id = +new Date();
  },
  resetList(state) {
    state.list = [];
    state.id = +new Date();
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
